import React, { createContext, useContext, useState, useEffect } from "react";
import { getProfile } from "../apis/apisList/commonApi";
import { getSettings } from "../apis/apisList/userApi";

// Create the app context
const AppContext = createContext();

// Provider for app state
export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [setting, setSetting] = useState({
    web_app_shut_down: false,
  });

  const [projectData, setProjectData] = useState([]);
  const [previewData, setPreviewData] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [pdfData, setPdfData] = useState(null);
  const [acceptedDate, setAcceptedDate] = useState(null);
  const [shouldWarn, setShouldWarn] = useState(!user);
  const [currentStep, setCurrentStep] = useState(0);
  const [prName, setPrName] = useState("");

  const login = (data) => {
    localStorage.setItem("user", JSON.stringify(data.user));
    localStorage.setItem("jwtToken", data.token);
    setUser(data.user);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("admin");
  };

  useEffect(() => {
    const response = localStorage.getItem("projectData") || null;
    if (response) {
      const res = JSON.parse(response);
      setPreviewData(res);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("jwtToken")) {
      getProfile()
        .then((res) => {
          setUser(res?.data);
          localStorage.setItem("user", JSON.stringify(res.data));
        })
        .catch((err) => {
          if (err.response?.status === 401) {
            logout();
          } else {
            console.error("Other error:", err);
          }
        });
    }
  }, []);

  useEffect(() => {
    getSettings().then((res) => {
      if (res?.data) {
        setSetting(res?.data);
      }
    });
  }, []);

  return (
    <AppContext.Provider
      value={{
        user,
        setUser,
        login,
        logout,
        projectData,
        setProjectData,
        setPreviewData,
        previewData,
        selectedOption,
        setSelectedOption,
        pdfData,
        setPdfData,
        acceptedDate,
        setAcceptedDate,
        setting,
        shouldWarn,
        setShouldWarn,
        currentStep,
        setCurrentStep,
        prName,
        setPrName,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// Custom hook to use the app context
export const useApp = () => useContext(AppContext);
